import React from 'react'
import '../../../styles/Idecaba.css'
function Cards() {
  return (
    <>
  <div className="container d-flex flex-column align-items-center py-3">
    {/* Tarjetas individuales */}
    <div className="card card-horizontal mb-3 w-90">
      <div className="card-body">
        <h3 className="card-title">
          <a href="" target="_blank" rel="noopener noreferrer" className="card-title-link text-decoration-underline">Normativa IDECABA</a>
        </h3>
      </div>
    </div>
    
    <div className="card card-horizontal mb-3 w-90">
      <div className="card-body">
        <h3 className="card-title">
          <a href="https://documentosboletinoficial.buenosaires.gob.ar/publico/20071214.pdf" target="_blank" rel="noopener noreferrer" className="card-title-link text-decoration-underline">Normativa de la Ley 2525</a>
        </h3>
      </div>
    </div>

    <div className="card card-horizontal mb-3 w-90">
      <div className="card-body">
        <h3 className="card-title">
          <a href="https://buenosaires.gob.ar/gobierno/normativa-de-acceso-la-informacion" target="_blank" rel="noopener noreferrer" className="card-title-link text-decoration-underline">Normativa de Acceso a la Información</a>
        </h3>
      </div>
    </div>

    <div className="card card-horizontal mb-3 w-90">
      <div className="card-body">
        <h3 className="card-title">
          <a href="https://www.idera.gob.ar/index.php/institucional/normativa" target="_blank" rel="noopener noreferrer" className="card-title-link text-decoration-underline">Normativas IDERA y Nacionales</a>
        </h3>
      </div>
    </div>

    {/* Acordeón con ancho ajustado */}
    <div className="accordion accordion-width-cards w-90 accordion-white" id="accordionUniqueSelection">
      <div className="accordion-item ">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTwoUniqueSelection"
          aria-expanded="false"
          aria-controls="collapseTwoUniqueSelection"
        >
          <span className="collapse-title accordion-padding">Normativa de los estándares: Normas ISO 19100, definidas por el ISO/TC211</span>
        </button>
        <div id="collapseTwoUniqueSelection" className="accordion-collapse collapse" data-bs-parent="#accordionUniqueSelection">
          <div className="accordion-body">
            <div className="card card-horizontal mb-3 w-90">
              <div className="card-body">
                <h3 className="card-title">
                  <a href="https://committee.iso.org/home/tc211" target="_blank" rel="noopener noreferrer" className="card-title-link text-decoration-underline">Comité ISO/TC 211</a>
                </h3>
              </div>
            </div>
            <div className="card card-horizontal mb-3 w-90">
              <div className="card-body">
                <h3 className="card-title">
                  <a href="https://www.isotc211.org/" target="_blank" rel="noopener noreferrer" className="card-title-link text-decoration-underline">ISO/TC 211</a>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>
  )
}

export default Cards